import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <AppSection />
        <FeaturesSection />
        <CardsSection />
        <ContactSection />
        <IndexSection />
        <TopicsSection />
        <CommentsSection />
        <AboutSection />
        <MediaSection />
        <RankingSection />
        <FaqSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}